var _a;
import { SubGroupConfiguration } from "../../data";
export var SubGroupFunctions = (_a = {},
    _a[SubGroupConfiguration.None] = {
        headings: "",
        events: "displayEventByMainGrouping"
    },
    _a[SubGroupConfiguration.League] = {
        headings: "displayLeagues",
        events: "displayEventsByLeague"
    },
    _a[SubGroupConfiguration.Time] = {
        headings: "displayHours",
        events: "displayEventsByTime"
    },
    _a);
//# sourceMappingURL=SubGroupFunctions.js.map